import React from 'react';
import Button from '@material-ui/core/Button';

const SignUpButton: React.FC = () => {
  return <Button size="small">Sign up</Button>;
};

export default SignUpButton;
